import { render, staticRenderFns } from "./CardSaoSilvestre.vue?vue&type=template&id=fb2204c2&scoped=true"
import script from "./CardSaoSilvestre.vue?vue&type=script&lang=js"
export * from "./CardSaoSilvestre.vue?vue&type=script&lang=js"
import style0 from "./CardSaoSilvestre.vue?vue&type=style&index=0&id=fb2204c2&prod&lang=scss"
import style1 from "./CardSaoSilvestre.vue?vue&type=style&index=1&id=fb2204c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2204c2",
  null
  
)

export default component.exports